var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrmIntegration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CRM_Integration_",
    "data-name": "CRM Integration ",
    transform: "translate(-16724 -8511)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_581",
    "data-name": "Ellipse 581",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(16724 8511)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "crm",
    transform: "translate(16762.018 8550.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19686",
    "data-name": "Path 19686",
    d: "M109.883,329.444a10,10,0,0,0,11.937,1.372l24.189-14.035a12.232,12.232,0,0,0,3.493-18.12l-.452-.549c-.419.034-11.557,0-11.557,0l-12.441,11.2a15.284,15.284,0,0,1-20.471-22.7l.07-.062L110,281.913h-6.376v-8.02l-5.67,5.671L85.071,266.681h-17.6v32.792l10.241.009Z",
    transform: "translate(-48.366 -191.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19687",
    "data-name": "Path 19687",
    d: "M259.379,266.681,246.5,279.564l-5.67-5.671v8.019H225.72l-12.713,11.019a6.79,6.79,0,0,0,9.125,10.057l14.862-13.342h13.542a7.016,7.016,0,0,0,7.008-7.008h8.494a15.481,15.481,0,0,1-6.043,12.269,20.7,20.7,0,0,1,2.327,4.866h14.661V266.681Z",
    transform: "translate(-151.12 -191.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19688",
    "data-name": "Path 19688",
    d: "M474.531,266.681H485.14V307.67H474.531Z",
    transform: "translate(-340.175 -191.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19689",
    "data-name": "Path 19689",
    d: "M0,266.681H10.609V307.67H0Z",
    transform: "translate(0 -191.175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19690",
    "data-name": "Path 19690",
    d: "M129.007,76.376l6.742-6.743a33.142,33.142,0,0,0,7.422,3.011v9.6h17.466v-9.6a33.14,33.14,0,0,0,7.422-3.011l6.742,6.743,12.35-12.353L180.6,57.468a33.188,33.188,0,0,0,3.322-7.611h9.1V32.387h-8.723a33.157,33.157,0,0,0-3.19-8.119l6.046-6.047L174.8,5.868l-5.858,5.859a33.155,33.155,0,0,0-8.306-3.518V0H143.171V8.209a33.155,33.155,0,0,0-8.306,3.518l-5.858-5.859-12.35,12.353,6.046,6.047a33.157,33.157,0,0,0-3.19,8.119H110.79V49.857h9.1a33.189,33.189,0,0,0,3.322,7.611l-6.554,6.555Zm43.836-35.9A20.939,20.939,0,1,1,151.9,19.53,20.965,20.965,0,0,1,172.843,40.473Z",
    transform: "translate(-79.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_626",
    "data-name": "Ellipse 626",
    cx: 12.445,
    cy: 12.449,
    rx: 12.445,
    ry: 12.449,
    transform: "translate(60.037 28.024)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrmIntegration);
export default __webpack_public_path__ + "static/media/CRM Integration.9fc56fb4f96c795801876a7444978c3b.svg";
export { ForwardRef as ReactComponent };